import { BygrProfile, BygrProfileDetails, BygrProject, PaginatedSearchRequest } from './../types';
import { request } from 'utils/ajax';
import { PaginationResult } from 'types';
import { toQueryString } from 'utils/url';
import { COUNTRY_CODES } from '@ygtechnologies/bygr-frontend-component-library';

export function getProfiles(req: PaginatedSearchRequest): Promise<PaginationResult<BygrProfile>> {
    return request(`api/profile`, { query: req }).then((x) => x.json());
}

export function getProfilesExportUrl(req: PaginatedSearchRequest) {
    return `api/profile/excel?${toQueryString(req)}`;
}
export function getProfileDetails(id: number): Promise<BygrProfileDetails> {
    return request(`api/profile/${id}`).then((x) => x.json());
}

export interface addProfileOptions {
    name: string;
    isPaying: boolean;
    currencyId: number;
    countryCode: keyof typeof COUNTRY_CODES;
}

export function addProfile({ name, isPaying, currencyId, countryCode }: addProfileOptions) {
    return request(`api/profile/`, {
        body: { name, isPaying, currencyId, countryCode },
        method: 'POST',
        json: true,
    });
}

export function setProfileSettings(
    profileId: number,
    settings: Pick<BygrProfileDetails, 'countryCode'> & { currencyId: number }
) {
    return request(`api/profile/${profileId}/profile-settings`, { body: settings, method: 'PATCH', json: true });
}

export function checkProfileName(profileName: string): Promise<string[]> {
    return request(`api/profile/check-profile-name`, { body: profileName, method: 'POST', json: true }).then((x) =>
        x.json()
    );
}

export function setIsPaying(profileId: number, isPaying: boolean) {
    return request(`api/profile/${profileId}/is-paying`, { body: { isPaying }, method: 'PATCH', json: true });
}

export function setAnalyticsIsEnabled(profileId: number, analyticsIsEnabled: boolean) {
    return request(`api/profile/${profileId}/analytics-enabled`, {
        body: { analyticsIsEnabled },
        method: 'PATCH',
        json: true,
    });
}

export function setProfileMemberIsAdmin(profileMemberId: number, isAdmin: boolean) {
    return request(`api/profile/member/${profileMemberId}/admin`, { body: { isAdmin }, method: 'POST', json: true });
}
export function deleteProfileMember(profileMemberId: number) {
    return request(`api/profile/member/${profileMemberId}`, { method: 'DELETE', json: true });
}

// export function getProfileFeatures(profileId: number): Promise<ProfileFeatureDTO[]> {
//     return request(`api/profile/${profileId}/features`).then((x) => x.json());
// }

export function getProfileContractorProjects(profileId: number): Promise<BygrProject[]> {
    return request(`api/profile/${profileId}/contractor-projects`).then((x) => x.json());
}
